import styled from '@emotion/styled'
import { theme } from '../../mui'
import { HomeListType, useTypeParam } from '../../state/url/type'
import { Button } from '../../components/Button/Button'

interface CreativeListSelectorProps {
  type: HomeListType
  count: number
}

interface WrapperProps {
  selected: boolean
}

const S = {
  Wrapper: styled.div<WrapperProps>`
    border-bottom: ${(props) =>
      props.selected ? `3px solid ${theme.palette.primary.main}` : undefined};
    cursor: pointer;
    font-weight: ${(props) => (props.selected ? 'bold' : undefined)};
    width: max-content;
    & a {
      text-decoration: unset;
    }
  `,
}

const CreativeListSelector = ({ type, count }: CreativeListSelectorProps) => {
  const [selectedType, setSelectedType] = useTypeParam()

  return (
    <>
      <S.Wrapper selected={selectedType === type.toString()}>
        <Button onClick={() => setSelectedType(type)} variant="link">
          <span>
            {type.toString().charAt(0) + type.toString().slice(1).toLowerCase()}{' '}
            ({count})
          </span>
        </Button>
      </S.Wrapper>
    </>
  )
}

export default CreativeListSelector
